import { render, staticRenderFns } from "./EventsOverview.vue?vue&type=template&id=bf5096f4&scoped=true&"
import script from "./EventsOverview.vue?vue&type=script&lang=ts&"
export * from "./EventsOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5096f4",
  null
  
)

export default component.exports